"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanToDownloadIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ScanToDownload_svg_1 = __importDefault(require("./ScanToDownload.svg"));
/**
 * Scan to download icon
 */
function ScanToDownloadIcon() {
    return (0, jsx_runtime_1.jsx)(ScanToDownload_svg_1.default, {});
}
exports.ScanToDownloadIcon = ScanToDownloadIcon;
//# sourceMappingURL=index.js.map